import { useT } from '../../i18n';
import { useAppStore } from '../../store/useAppStore';
import { Icon } from '../../ui/Icon';
import styles from './Schlafscheibe.module.css';

/**
 * Der Knopf, der die Scheibe legt und wieder wegnimmt — in zwei Gestalten.
 *
 * **Warum zwei.** Im Bogen gibt es eine Fusszeile, und dort gehört er hin: neben „Absenden",
 * wo die Hand ohnehin liegt, statt als schwebender Fleck über der Aufgabenliste (Entscheidung
 * des Nutzers, 2026-09-13). In der Auswahl und beim Wiedereinstieg gibt es keine Fusszeile —
 * dort schwebt er weiter unten rechts.
 *
 * ⚠️ **Im Schlaf ist nur die schwebende Gestalt zu gebrauchen.** Die Scheibe liegt über der
 * Fusszeile; ein Knopf darunter wäre sichtbar, aber tot. Deshalb zeigt `Schlafscheibe` ihre
 * Ecke auch dann, wenn der Knopf sonst im Fuss sitzt.
 */
export function SchlafKnopf({ gestalt }: { gestalt: 'fuss' | 'schwebend' }) {
  const t = useT();
  const schlaeft = useAppStore((s) => s.schlaeft);
  const setSchlaeft = useAppStore((s) => s.setSchlaeft);

  return (
    <button
      type="button"
      className={`tap ${gestalt === 'fuss' ? styles.fussKnopf : styles.knopf}`}
      onClick={() => setSchlaeft(!schlaeft)}
      aria-label={schlaeft ? t.sleep.wake : t.sleep.sleep}
      title={schlaeft ? t.sleep.wake : t.sleep.sleep}
    >
      <Icon name="sleep" size={schlaeft ? 26 : 20} />
      {/* Die Beschriftung trägt nur die schwebende Gestalt, und nur im Schlaf: dort steht sie
          allein auf dunklem Grund und muss sich erklären. Im Fuss steht sie neben „Absenden",
          wo ein zweiter Wortknopf den wichtigen Knopf schmäler machte. */}
      {schlaeft && gestalt === 'schwebend' && <span className={styles.knopfText}>{t.sleep.wake}</span>}
    </button>
  );
}
